import { AfterViewInit, OnDestroy, ViewChild, Component, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { SharedService } from '../shared.service';
import { DataTableDirective } from 'angular-datatables';
import * as mail from '@sendgrid/mail';
import swal from 'sweetalert';
import { AppConfigService } from '../app-config.service';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, OnChanges {
  summaryList: any = [];
  employeeList: any = [];
  Date: any;
  month: any = 'January';
  monthDropdown =
    [
      { Value: 1, Text: 'January' },
      { Value: 2, Text: 'February' },
      { Value: 3, Text: 'March' },
      { Value: 4, Text: 'April' },
      { Value: 5, Text: 'May' },
      { Value: 6, Text: 'June' },
      { Value: 7, Text: 'July' },
      { Value: 8, Text: 'August' },
      { Value: 9, Text: 'September' },
      { Value: 10, Text: 'October' },
      { Value: 11, Text: 'November' },
      { Value: 12, Text: 'December' }
    ]
  monthNum: any = new Date().getMonth() + 1;
  year: any = new Date().getFullYear();
  yearDropdown: number[] = [];
  activateEncash = false;
  modalTitle = '';
  summary: any;
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  mailBody: any;
  summaryLastGenerated: any;
  summaryLastGeneratedFor: any;
  settingId = 3;
  constructor(private service: SharedService, private appSettings: AppConfigService) { }
  ngOnInit(): void {
    var currentYear = new Date().getFullYear();
    this.yearDropdown = [];
    for (let yearItem = this.appSettings.getStartYear(); yearItem <= currentYear; yearItem++) {
      this.yearDropdown.push(yearItem);
    }
    this.dtOptions =
    {
      pagingType: 'full_numbers',
      pageLength: 50
    };
    //this.month = this.GetCurrentMonth();
    this.GetMonthName(this.monthNum);
    this.Date = this.GetCurrentDate();
    this.RefreshSummaryList();
    this.RefreshEmployeeList();
    this.GetLastImportDate(this.settingId);
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }
  Test() {
    // this.SetLastSummaryDate(this.settingId);
  }
  GetLastImportDate(settingId: number) {
    this.service.GetSetting(settingId).subscribe(data => {
      this.summaryLastGenerated = data[0].LastSummaryDate,
      this.summaryLastGeneratedFor = data[0].LastSummaryFor
    });
  }
  UpdateCasualAdded(event: any, pkSummaryId: number) {
    var changedValue = event.target.textContent;
    var summary = this.summaryList.find(((summary: { pkSummaryId: number; }) => summary.pkSummaryId === pkSummaryId))
    var change = changedValue - summary.CasualBalanceAdded;
    summary.CasualBalanceAdded = changedValue;
    summary.NewCasualBalance = summary.NewCasualBalance + change;
    swal
      ({
        title: "Are you sure?",
        text: "you want to change Casual Added from " + (changedValue - change) + " to " + changedValue,
        icon: "warning",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
      })
      .then((confirm) => {
        if (confirm) {
          this.service.AddSummary(summary).subscribe(data => {
            swal('Summary Table Updated', '', "success")
          },
            (err) => {
              swal('Validation Error', 'Please enter a valid number with no spaces', "error")
            });
        }
        else {
          window.location.reload();
        }
      });
  }
  UpdateAnnualAdded(event: any, pkSummaryId: number) {
    var changedValue = event.target.textContent;
    var summary = this.summaryList.find(((summary: { pkSummaryId: number; }) => summary.pkSummaryId === pkSummaryId))
    var change = changedValue - summary.AnnualBalanceAdded;
    summary.AnnualBalanceAdded = changedValue;
    summary.NewAnnualBalance = summary.NewAnnualBalance + change;
    swal
      ({
        title: "Are you sure?",
        text: "you want to change Annual Added from " + (changedValue - change) + " to " + changedValue,
        icon: "warning",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
      })
      .then((confirm) => {
        if (confirm) {
          this.service.AddSummary(summary).subscribe(data => {
            swal('Summary Table Updated', '', "success")
          },
            (err) => {
              swal('Validation Error', 'Please enter a valid number with no spaces', "error")
            });
        }
        else {
          window.location.reload();
        }
      });
  }
  UpdateNEL(event: any, pkSummaryId: number) {
    var changedValue = event.target.textContent;
    var summary = this.summaryList.find(((summary: { pkSummaryId: number; }) => summary.pkSummaryId === pkSummaryId))
    var change = (changedValue - summary.NotEnoughLeaves);
    summary.NotEnoughLeaves = changedValue;
    summary.NewCasualBalance = summary.NewCasualBalance + change;
    //summary.CasualLeaves = summary.CasualLeaves - change;
    swal
      ({
        title: "Are you sure?",
        text: "you want to change NEL from " + (changedValue - change) + " to " + changedValue,
        icon: "warning",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
      })
      .then((confirm) => {
        if (confirm) {
          this.service.AddSummary(summary).subscribe(data => {
            swal('Summary Table Updated', '', "success")
          },
            (err) => {
              swal('Validation Error', 'Please enter a valid number with no spaces', "error")
            });
        }
        else {
          window.location.reload();
        }
      });
  }
  GetCurrentMonth() {
    const today = new Date();
    var monthName = today.toLocaleString('default', { month: 'long' });
    return monthName;
  }
  GetCurrentDate() {
    let today = new Date().toISOString().slice(0, 10)
    return today
  }
  RefreshSummaryList() {
    this.service.GetSummariesForMonth(this.monthNum, this.year).subscribe(data => {
      this.summaryList = data;
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Destroy the table first
        dtInstance.destroy();
        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    });
  }
  FindEmployeeName(id: number) {
    for (var employee of this.employeeList) {
      if (employee.pkEmpId == id) {
        return (employee.FirstName + ' ' + employee.LastName);
      }
    }
    return ('Employee not found')
  }
  FindEmployeeEmail(id: number) {
    for (var employee of this.employeeList) {
      if (employee.pkEmpId == id) {
        return (employee.EmpEmail);
      }
    }
    return ('Employee not found')
  }
  GetEmployeeCasualBalance(id: number) {
    for (var employee of this.employeeList) {
      if (employee.pkEmpId == id) {
        return employee.CasualLeaveBalance;
      }
    }
    return ('Employee not found')
  }
  GetEmployeeAnnualBalance(id: number) {
    for (var employee of this.employeeList) {
      if (employee.pkEmpId == id) {
        return employee.AnnualLeaveBalance;
      }
    }
    return ('Employee not found')
  }
  RefreshEmployeeList() {
    this.service.GetEmpList().subscribe(data => {
      this.employeeList = data;
    });
  }
  UpdateMonth(month: number, MonthName: string) {
    this.month = MonthName;
    this.monthNum = month;
    this.RefreshSummaryList();
  }
  UpdateYear(year: number) {
    this.year = year;
    this.RefreshSummaryList();
  }
  GetMonthName(monthNum: number) {
    var temp = this.monthDropdown.find(i => i.Value === monthNum);
    this.month = temp?.Text;
  }
  CloseMonth() {
    if (confirm('Are you sure? \nThis action will update the new leave balances and commit changes to the database. \nThis cannot be undone.')) {
      for (var employee of this.employeeList) {
        for (var summary of this.summaryList) {
          if (employee.pkEmpId == summary.fkEmpId) {
            var emp =
            {
              pkEmpId: employee.pkEmpId,
              FirstName: employee.FirstName,
              LastName: employee.LastName,
              Gender: employee.Gender,
              Age: employee.Age,
              EmpEmail: employee.EmpEmail,
              Designation: employee.Designation,
              ContactNumber: employee.ContactNumber,
              CasualLeaveBalance: summary.NewCasualBalance,
              AnnualLeaveBalance: summary.NewAnnualBalance,
              IsPermanent: employee.IsPermanent,
              ClockifyId: employee.ClockifyId,
              OnLeave: employee.OnLeave,
              MaternityLimit: employee.MaternityLimit
            }
            this.service.UpdateEmployee(emp).subscribe(data => {
              console.log(data)
            });
          }
        }
      }
    }
  }
  CloseClick() {
    this.activateEncash = false;
    this.RefreshSummaryList();
    this.RefreshEmployeeList();
  }
  OpenEncashModule(summary: any) {
    this.modalTitle = "Enter the amount of leaves to be cashed"
    this.summary = summary;
    this.activateEncash = true;
  }
  async SendMail() {
    for (var summary of this.summaryList) {
      var email =
      {
        nameFrom: this.appSettings.getSendGridNameFrom(),
        emailFrom: this.appSettings.getSendGridEmailFrom(),
        nameTo: this.FindEmployeeName(summary.fkEmpId),
        emailTo: this.appSettings.getIsLive() ? this.FindEmployeeEmail(summary.fkEmpId) : this.appSettings.getTestEmailTo(),
        subject: 'Leave Account',
        content: `
      <h1 align="center">Leave Account for ${this.FindEmployeeName(summary.fkEmpId)}</h1>
      <h3 align="center">For the month of ${this.month} ${this.year}</h3>
      <table align = "center" border="2px" cellpadding="5" cellspacing="0"
        style = "margin-top:10px">
          <tr bgcolor="#FFFFFF">
            <th style = "text-align:left">Casual balance brought forward</th>
            <td style = "text-align:right">${summary.OldCasualBalance.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#ECECEC">
            <th style = "text-align:left">Annual balance brought forward</th>
            <td style = "text-align:right">${summary.OldAnnualBalance.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#FFFFFF">
            <th style = "text-align:left">New Casual Leaves</th>
            <td style = "text-align:right">${summary.CasualBalanceAdded.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#ECECEC">
            <th style = "text-align:left">New Annual Leaves</th>
            <td style = "text-align:right">${summary.AnnualBalanceAdded.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#FFFFFF">
            <th style = "text-align:left">Casual Leaves availed</th>
            <td style = "text-align:right">${summary.CasualLeaves.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#ECECEC">
            <th style = "text-align:left">Annual Leaves availed</th>
            <td style = "text-align:right">${summary.AnnualLeaves.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#FFFFFF">
            <th style = "text-align:left">Off Days Worked</th>
            <td style = "text-align:right">${summary.OffDaysWorked.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#ECECEC">
            <th style = "text-align:left">Deduction: Leaves without pay</th>
            <td style = "text-align:right">${summary.LWP.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#FFFFFF">
            <th style = "text-align:left">Deduction: Not enough leaves</th>
            <td style = "text-align:right">${summary.NotEnoughLeaves.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#ECECEC">
            <th style = "text-align:left">Casual balance carried forward</th>
            <td style = "text-align:right">${summary.NewCasualBalance.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#FFFFFF">
            <th style = "text-align:left">Annual balance carried forward</th>
            <td style = "text-align:right">${summary.NewAnnualBalance.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#ECECEC">
            <th style = "text-align:left">Annual leaves lapsed</th>
            <td style = "text-align:right">${summary.LeavesLapsed.toFixed(2)}</td>
          </tr>
          <tr bgcolor="#FFFFFF">
            <th style = "text-align:left">Leaves encashed </th>
            <td style = "text-align:right">${summary.LeavesCashed.toFixed(2)}</td>
          </tr>
      </table>
      <h5>In case of any discrepancies or confusions, please contact me.</h5>
      <p>Regards, <br>
      Rahim. </p>
      `
      }
      //console.log(email);
      await new Promise(resolve => this.service.SendEmail(email).subscribe(data => {
        resolve(data)
        swal("SUCCESS", "Email sent successfully", "success")
        this.mailBody = "data"
      },
        error => {
          swal("ERROR", "Email not sent successfully", "error")
        }));
    }
  }
}